import { render, staticRenderFns } from "./FaqDetail.vue?vue&type=template&id=d97802ba&scoped=true"
import script from "./FaqDetail.vue?vue&type=script&lang=js"
export * from "./FaqDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97802ba",
  null
  
)

export default component.exports